module.exports = __webpack_public_path__ + "components/promo-premium/static/snow-pro__logo--white-0ee0457d7726e508d7f5f6ad88248671.svg";